export enum EmbeddedTravellerFormMessageId {
    onSuccess = 'embeddedTravellersFormSuccess',
    onError = 'embeddedTravellersFormError'
}
